import axiosClient from "./axiosClient";

//test 11/09

const authApi = {
    signUpStep1: (data) => {
        const baseURL = "user/signup/step1";
        return axiosClient.post(baseURL, {
            email: data.email,
        });
    },
    signUpStep2: (data) => {
        const baseURL = "user/signup/step2";
        return axiosClient.post(baseURL, {
            email: data.email,
            OTPCode: data.OTPCode,
        });
    },
    signUpStep3: (data) => {
        const baseURL = "user/signup/step3";
        return axiosClient.post(baseURL, {
            email: data.email,
            password: data.password,
            oneTimeToken: data.oneTimeToken,
        });
    },
    login: (data) => {
        const baseURL = "user/login";
        return axiosClient.post(baseURL, {
            email: data.email,
            password: data.password,
        });
    },
    getUserInfo() {
        const baseURL = "user/get-me";
        return axiosClient.get(baseURL);
    },
    updateMe(data) {
        const baseURL = "user/update-me";
        return axiosClient.post(baseURL, data);
    },
    getOTP() {
        const baseURL = "user/otp";
        return axiosClient.get(baseURL);
    },
    verifyOTP(data) {
        const baseURL = "user/otp";
        return axiosClient.post(baseURL, {
            OTPCode: data.OTPCode,
        });
    },
    setOtpNewEmail(data) {
        const baseURL = "user/send-otp-new-email";
        return axiosClient.post(baseURL, {
            oneTimeToken: data.oneTimeToken,
            newEmail: data.newEmail,
        });
    },
    changeEmail: (data) => {
        const baseURL = "user/change-email";
        return axiosClient.post(baseURL, {
            newEmail: data.newEmail,
            OTPCode: data.OTPCode,
            isMiddleware: true,
        });
    },
    changePassword: (data) => {
        const baseURL = "user/change-password";
        return axiosClient.post(baseURL, {
            newPassword: data.newPassword,
            oneTimeToken: data.oneTimeToken,
        });
    },
    changeBankInfo: (data) => {
        const baseURL = "user/change-bank-info";
        return axiosClient.post(baseURL, {
            bankInfo: data.bankInfo,
            oneTimeToken: data.oneTimeToken,
        });
    },
    forgotPassword: (data) => {
        const baseURL = "user/forgot-password";
        return axiosClient.post(baseURL, {
            email: data.email,
        });
    },
    verifyForgotPassword: (data) => {
        const baseURL = "user/verify-reset-password";
        return axiosClient.post(baseURL, {
            email: data.email,
            OTPCode: data.OTPCode,
        });
    },
    resetPassword: (data) => {
        const baseURL = "user/reset-password";
        return axiosClient.post(baseURL, {
            newPassword: data.newPassword,
            oneTimeToken: data.oneTimeToken,
        });
    },
    myOrders: (queryString) => {
        const baseURL = `user/my-orders?${queryString || ""}`;
        return axiosClient.get(baseURL);
    },
    myPendingCash: () => {
        const baseURL = `user/my-pending-cash`;
        return axiosClient.get(baseURL);
    },
    getAllUser(queryString) {
        const baseURL = `user/all_user?${queryString || ""}`;
        return axiosClient.get(baseURL);
    },
    topCommission(queryString) {
        const baseURL = `user/top_commission?${queryString || ""}`;
        return axiosClient.get(baseURL);
    },
    topPendingCash(queryString) {
        const baseURL = `user/top_pending_cash?${queryString || ""}`;
        return axiosClient.get(baseURL);
    },
    topWithDraw(queryString) {
        const baseURL = `user/top_withdraw?${queryString || ""}`;
        return axiosClient.get(baseURL);
    },
    getAllOrder(queryString) {
        const baseURL = `user/all_order?${queryString || ""}`;
        return axiosClient.get(baseURL);
    },
    // Xuất CSV toàn bộ đơn theo đúng bộ lọc đang xem (không chỉ trang hiện tại).
    exportOrders(queryString) {
        const baseURL = `user/export-orders?${queryString || ""}`;
        return axiosClient.get(baseURL, { responseType: "blob" });
    },
    getCampaign() {
        const baseURL = `campaign/get_campaigns`;
        return axiosClient.get(baseURL);
    },
    updateCampaign(data) {
        const baseURL = `campaign`;
        return axiosClient.post(baseURL, data);
    },
    orderAnalytic(queryString) {
        const baseURL = `user/order_analytic?conversionStatus=2&${queryString || ""}`;
        return axiosClient.get(baseURL);
    },
    paymentAnalytic(queryString) {
        const baseURL = `user/payment_analytic?status=2&${queryString || ""}`;
        return axiosClient.get(baseURL);
    },
    setOrderComplete(orderId) {
        const baseURL = `user/set_complete_order`;
        return axiosClient.post(baseURL, {
            orderId,
        });
    },
    // Lấy dữ liệu mới nhất 1 đơn từ Shopee (trạng thái, hoa hồng SP, giá trị đơn) + update DB
    checkOrder(orderId) {
        const baseURL = `user/check_order`;
        return axiosClient.post(baseURL, { orderId });
    },
    // Thu hồi hoa hồng đơn đã duyệt (trừ lại cash + đánh dấu đã huỷ)
    revokeOrderCommission(orderId) {
        const baseURL = `user/revoke_order_commission`;
        return axiosClient.post(baseURL, { orderId });
    },
    getBonusHistory(params) {
        return axiosClient.get(`bonus/bonus_history`, { params });
    },
    // Xuất CSV sổ thưởng / trừ tiền theo bộ lọc đang xem.
    exportBonusHistory(params) {
        return axiosClient.get(`bonus/bonus_history/export`, { params, responseType: "blob" });
    },
    bonusCash(data) {
        const baseURL = `bonus/bonus_cash`;
        return axiosClient.post(baseURL, data);
    },
    bonusMany(data) {
        const baseURL = `bonus/bonus_many`;
        return axiosClient.post(baseURL, data);
    },
    bonusManyAdvanced(data) {
        const baseURL = `bonus/bonus_advanced`;
        return axiosClient.post(baseURL, data);
    },
    lockAccount(userId, reason) {
        const baseURL = `user/lock-account`;
        return axiosClient.post(baseURL, {
            userId,
            reason: reason || "",
        });
    },
    unlockAccount(userId, reason) {
        const baseURL = `user/unlock-account`;
        return axiosClient.post(baseURL, {
            userId,
            reason: reason || "",
        });
    },
    deductFraudMoney(userId, amount, reason) {
        const baseURL = `user/deduct-fraud`;
        return axiosClient.post(baseURL, {
            userId,
            amount,
            reason,
        });
    },
    loginAsUser(userId) {
        const baseURL = `user/login-as-user`;
        return axiosClient.post(baseURL, { userId });
    },
    // Phân quyền CTV: set role (user<->mod) + permissions cho 1 user.
    updateUserPermissions(userId, { role, permissions }) {
        const baseURL = `user/${userId}/permissions`;
        return axiosClient.patch(baseURL, { role, permissions });
    },
    // Đổi email hộ thành viên (admin only) — ca user mất quyền truy cập email cũ nên
    // không tự đổi được bằng OTP. Chuyển từ php admin `user/change_email.php`.
    changeUserEmail(userId, newEmail) {
        return axiosClient.patch(`user/${userId}/email`, { newEmail });
    },
    // Danh sách tất cả CTV (role='mod').
    getMods() {
        return axiosClient.get(`user/all_mods`);
    },
    getAllRefs(queryString) {
        const baseURL = `user/all-refs?${queryString || ""}`;
        return axiosClient.get(baseURL);
    },
    getRefsByUserId(userId, queryString) {
        const baseURL = `user/refs-by-user/${userId}?${queryString || ""}`;
        return axiosClient.get(baseURL);
    },
    getRefStatistics(queryString) {
        const baseURL = `user/ref-statistics?${queryString || ""}`;
        return axiosClient.get(baseURL);
    },
    exportRefs(queryString) {
        const baseURL = `user/export-refs?${queryString || ""}`;
        return axiosClient.get(baseURL, { responseType: "blob" });
    },
    getReferredUsers(queryString) {
        const baseURL = `user/referred-users?${queryString || ""}`;
        return axiosClient.get(baseURL);
    },
    // ── Gán / đổi / gỡ người giới thiệu (admin + CTV quyền "referral") ──
    // Tìm người giới thiệu theo userId / email / tên.
    lookupReferrer(q) {
        return axiosClient.get(`user/referrer-lookup?q=${encodeURIComponent(q)}`);
    },
    // Xem trước tác động (điều kiện chặn, hạn 3 tháng, số đơn + tiền backfill) trước khi lưu.
    previewReferrerChange(userId, refId) {
        const suffix = refId == null ? "" : `?refId=${refId}`;
        return axiosClient.get(`user/${userId}/referrer-preview${suffix}`);
    },
    // refId = null nghĩa là gỡ người giới thiệu. backfillMode: none | unpaid | all.
    updateUserReferrer(userId, { refId, backfillMode, notify }) {
        return axiosClient.patch(`user/${userId}/referrer`, { refId, backfillMode, notify });
    },
    /** Top commission leaderboard – supports startTime/endTime as Unix timestamps */
    topUserMonth(queryString) {
        return axiosClient.get(`user/top_user_month?${queryString || ""}`);
    },
    /** Top orders leaderboard – supports startTime/endTime as Unix timestamps */
    topUserOrders(queryString) {
        return axiosClient.get(`user/top_user_orders?${queryString || ""}`);
    },

    // ── App Rate Promos (X2/X3 cashback campaigns) ──
    getPromos() {
        return axiosClient.get(`app-rate-promo`);
    },
    createPromo(data) {
        return axiosClient.post(`app-rate-promo`, data);
    },
    updatePromo(id, data) {
        return axiosClient.put(`app-rate-promo/${id}`, data);
    },
    deletePromo(id) {
        return axiosClient.delete(`app-rate-promo/${id}`);
    },
};

export default authApi;
